import { render, staticRenderFns } from "./areaAnalysis.vue?vue&type=template&id=072f0a70&"
import script from "./areaAnalysis.vue?vue&type=script&lang=js&"
export * from "./areaAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports